import { render, staticRenderFns } from "./view-single-project-details.vue?vue&type=template&id=8fae2fe2&"
import script from "./view-single-project-details.vue?vue&type=script&lang=js&"
export * from "./view-single-project-details.vue?vue&type=script&lang=js&"
import style0 from "./view-single-project-details.vue?vue&type=style&index=0&id=8fae2fe2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports